import { Component, OnInit, ViewChild, Output, EventEmitter, Input } from '@angular/core';
import { PlatformLocation } from '@angular/common';
import { NgbActiveModal, NgbTypeahead } from '@ng-bootstrap/ng-bootstrap';
import { ProfessionalCertsService, AuthService, CandidatesService } from '../../../../services';
import { Observable, Subject, merge, OperatorFunction } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, map } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-professional-certificates-modal',
    templateUrl: './professional-certificates-modal.html',
    styleUrls: ['./professional-certificates-modal.scss']
})

export class ProfessionalCertificatesModalComponent implements OnInit {
    @ViewChild('instanceProfCert', { static: false }) _instance: NgbTypeahead;
    @Output() notifyParent = new EventEmitter<any>();
    @Input() isEdit = false;
    @Input() profCert = {
        id: null,
        issuance_date: null,
        is_certified: null,
        specialization: null,
        certification: null,
        professional_certificate_id: null,
        professional_certificate_name: null,
        issuer: null,
        no_exp_date: false,
        expiration_date: null
    }
    checkConfirm = false;
    professional_certs = [];
    isLoading = false;
    constructor(private toastr: ToastrService, private profCertService: ProfessionalCertsService, private candidatesService: CandidatesService, private authService: AuthService, private location: PlatformLocation, public activeModal: NgbActiveModal) {
        location.onPopState(() => { this.activeModal.close(); });
    }

    ngOnInit() {
        this.profCertService.getAll().subscribe((res: any) => { this.professional_certs = res.data; });
    }

    closeModal() {
        this.activeModal.close({ status: true });
    }

    canAdd() {
        return this.isLoading || (this.profCert.issuance_date == null || this.profCert.specialization == null) || (this.checkConfirm == false);
    }

    _formatter = (professional_cert: any) => professional_cert.professional_cert_name_en || professional_cert;
    _focus$ = new Subject<string>();
    _click$ = new Subject<string>();
    _search: OperatorFunction<string, readonly { id, professional_cert_name_en }[]> = (text$: Observable<string>) => {
        text$.pipe(debounceTime(200), distinctUntilChanged());
        const debouncedText$ = text$.pipe(debounceTime(200), distinctUntilChanged());
        const clicksWithClosedPopup$ = this._click$.pipe(filter(() => !this._instance.isPopupOpen()));
        const inputFocus$ = this._focus$;

        return merge(debouncedText$, inputFocus$, clicksWithClosedPopup$).pipe(map(term => (term === '' ? this.professional_certs.slice(0, 10)
            : this.professional_certs.filter(professional_cert => new RegExp(term, 'mi').test(professional_cert.professional_cert_name_en) || new RegExp(term, 'mi').test(professional_cert.professional_cert_name_ar)).slice(0, 10)))
        )
    }

    selectCertificate() {
        this.profCert.professional_certificate_name = (typeof this.profCert.certification == 'string') ? this.profCert.certification : null;
    }

    updateUserProfile() {
        this.profCert.professional_certificate_id = this.profCert.certification?.id

        var _prof = Object.assign({}, this.profCert);
        this.isLoading = true;
        if (!this.isEdit)
            this.candidatesService.addProfCert(_prof, this.authService.user.candidate?.id).subscribe((res: any) => {
                this.isLoading = false;
                this.profCert = {
                    id: null,
                    issuance_date: null,
                    is_certified: null,
                    specialization: null,
                    certification: null,
                    professional_certificate_id: null,
                    professional_certificate_name: null,
                    issuer: null,
                    no_exp_date: false,
                    expiration_date: null
                };
                this.notifyParent.emit(true);
                this.closeModal();
            }, (error: any) => {
                this.isLoading = false;
                this.toastr.error(error.statusText, "update profile information");
            });
        else
            this.candidatesService.updateProfCert(_prof, this.authService.user.candidate?.id, this.profCert.id).subscribe((res: any) => {
                this.isLoading = false;
                this.profCert = res.data;
                this.notifyParent.emit(true);
                this.closeModal();
            }, (error: any) => {
                this.isLoading = false;
                this.toastr.error(error.statusText, "update profile information");
            });
    }

    resetDate() {
        if (this.profCert.no_exp_date)
            this.profCert.expiration_date = null;
    }
}






